import { createTheme } from 'flowbite-react';

export const theme = createTheme({
    fileInput: {
        base: 'block w-full cursor-pointer rounded-lg border file:-ms-4 file:me-4 file:cursor-pointer file:border-none file:bg-primary-700 file:py-2.5 file:pe-4 file:ps-8 file:text-sm file:font-medium file:leading-[inherit] file:text-white hover:file:bg-primary-800 focus:outline-none focus:ring-2',

        colors: {
            primary:
                'border-gray-300 bg-gray-50 text-gray-900 focus:ring-primary-600',
            dark: 'border-gray-600 bg-gray-700 text-gray-400 focus:ring-primary-600',
        },
    },
}).fileInput;
